var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M8,0,0,10.838H16Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M90.668,0l-8,10.839h16Z",
    transform: "translate(-66.668)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M173.169,0l-8,10.839h16Z",
    transform: "translate(-133.2)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M90.668,93.161,82.665,56Z",
    transform: "translate(-66.665 -45.162)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M124,93.161,132,56Z",
    transform: "translate(-100 -45.162)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    d: "M41.5,0l7.967,10.839L57.468,0Z",
    transform: "translate(-33.468)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    d: "M123.916,0l7.967,10.839,8-10.839Z",
    transform: "translate(-99.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    d: "M132.013,56l-8,37.161,24-37.161Z",
    transform: "translate(-100.012 -45.162)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M82.664,56l8,37.161,8-37.161Z",
    transform: "translate(-66.665 -45.162)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    "data-name": "Path 7378",
    d: "M0,56,24,93.162,16,56Z",
    transform: "translate(0 -45.162)",
    fill: "#00feff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlan);
export default __webpack_public_path__ + "static/media/basic-plan.cb534e8269590e79ef8d706ae99b00c5.svg";
export { ForwardRef as ReactComponent };